import {initElements} from "../define/shared"

export default function initHeader() {
    initElements(".siteHeader", header => {
        const hambBtn = header.querySelector('.siteHeader-hamb'),
            menu = header.querySelector('.siteHeader-menu')
        const closeBtn = document.createElement('span')

        closeBtn.classList.add('icon', 'icon-close')
        menu.appendChild(closeBtn)

        hambBtn.addEventListener('click', () => {
            menu.classList.add('is--open')
        })

        closeBtn.addEventListener('click', () => {
            menu.classList.remove('is--open')
        })
    })
}
